import React from 'react';
import store from 'store';
import u from '../utilities/Utilities';

export default class GuestRedirect extends React.Component{

    componentDidMount=()=>{
        const token = u.getQuery(this.props,"token");
        if(token){
            store.set("access-card-token",token);
            window.location="/access-card"
        }
        else{
            window.location="/not-found";
        }
    }

    render(){
        return (<div/>)
    }
}